<template>
  <div :class="getListClass()">
      <yxt-empty v-if="!groupList.length"></yxt-empty>
      <yxt-scrollbar :fit-height="true" ref="scrollRef">
        <div class="group-list_box">
          <Item 
              v-for="group of groupList" 
              :key="`grp_${group.id}`" 
              :info="group"
              :mode="mode"
              :id="id"
              :dragging="dragging"
              @select="onSelect"
          ></Item>
        </div>
      </yxt-scrollbar>
  </div>
</template>

<script>
import { Empty, Scrollbar } from 'yxt-pc';
import Item from './group-item.vue';
import { initScroll, setScroll, release } from '../../../services/scroll';

export default {
  components: {
    'yxt-empty': Empty,
    'yxt-scrollbar': Scrollbar,
    Item
  },
  props: {
    groupList: {
      type: Array,
      require: true
    },
    mode: {
      type: String,
      default: 'default'
    },
    id: {
      type: String,
      default: ''
    },
    dragging: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    dragging() {
      setScroll(this.dragging);
    }
  },
  mounted() {
    initScroll(this.$refs.scrollRef.wrap, this.dragging);
  },
  beforeDestroy() {
    release();
  },
  methods: {
    getListClass() {
      if (this.groupList.length) {
        return 'group-list';
      }
      return 'group-list group-list-empty';
    },
    onSelect(id) {
      return this.$emit('select', id);
    }
  }
};
</script>

<style lang="scss" scoped>
.group-list{
    height: 100%;
    overflow-y: hidden;
    margin-right: -24px;
    &_box{
      width: 100%;
      height: 100%;
      padding-right: 24px;
    }
}
.group-list-empty{
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
